export class Maestro_Grupos_Menu {
    id: number;
    idGrupo: number;
    grupo: string;
    idMenuPadre: number;
    nombre: string;
    componente: string;
    orden: number;
    icono: string;
    activo: boolean;
    requiereAliado: boolean;
    requiereCanal: boolean;
}

export class TodoItemNode {
    children: TodoItemNode[];
    id: string;
    item: string;
    icon: string;
    idParent: string;
    idFilter: number;
}

export class TodoItemFlatNode {
    id: string;
    item: string;
    level: number;
    icon: string;
    idParent: string;
    idFilter: number;
    expandable: boolean;
}